require.register("app/seller/show/InfoTab", function(exports, require, module){
  $0
  
});

